const navList = {
  walkthrough_navs: [
    {
      name: '精选',
      // tagId: 4018,
      // fixed: true,
      targetRouterName: 'index',
      // adId: '16241:21648',
    },
    // {
    //   name: '夺冠之路',
    //   targetRouterName: 'road',
    // },
    // {
    //   name: '版本爆料',
    //   targetRouterName: 'edition',
    //   children: [
    // {
    //   name: '版本爆料',
    //   targetRouterName: 'edition',
    // },
    // {
    //   name: '版本专题',
    //   targetRouterName: 'edition-feature',
    // },
    // {
    //   name: '版本攻略',
    //   targetRouterName: 'edition-strategy',
    //   children: [
    //     {
    //       name: '精品攻略',
    //       targetRouterName: 'edition-strategy',
    //     }, {
    //       name: '玩家攻略',
    //       targetRouterName: 'edition-short',
    //     },
    //   ],
    // },
    // {
    //   name: '社区活动',
    //   targetRouterName: 'edition-vote',
    //   children: [
    //   //   {
    //   //   name: '版本任务',
    //   //   targetRouterName: 'edition-news',
    //   // },
    //     {
    //       name: '版本话题',
    //       targetRouterName: 'edition-vote',
    //     }],
    // },
    // {
    //   name: '皮肤爆料站',
    //   targetRouterName: 'edition-skin',
    // },

    // {
    //   name: '更多爆料',
    //   targetRouterName: 'more-edition',
    // },
    // {
    //   name: '拍脸版本爆料测试入口',
    //   targetRouterName: 'activityEdition',
    // },
    //   ],
    // },
    // {
    //   name: '一句话攻略',
    //   targetRouterName: 'stragegy',
    //   children: [
    //     {
    //       name: '大家都在看',
    //       targetRouterName: 'stragegy',
    //     },
    //     {
    //       name: '今日最新',
    //       targetRouterName: 'stragegynews',
    //     },
    //     {
    //       name: '攻略百科',
    //       targetRouterName: 'stragegybaike',
    //     },
    //     // {
    //     //   name: '攻略活动',
    //     //   targetRouterName: 'solicitation-tag',
    //     // },
    //   ],
    // },
    // {
    //   name: '大神攻略',
    //   targetRouterName: 'manito',
    // },

  ],
  tools_navs: [
    {
      name: '地图资源',
      targetRouterName: 'map',
    },
    {
      name: '大神灵敏度',
      targetRouterName: 'sensitivity',
      href: '',
    },
    {
      name: '键位布局',
      targetRouterName: 'mapping',
    },
    {
      name: '音乐专区',
      targetRouterName: 'music-boutique',
      children: [
        // music-boutique
        // music-tab-精品
        {
          name: '精品',
          targetRouterName: 'music-boutique',
        },
        // music-index
        // music-tab-全部音乐
        {
          name: '全部音乐',
          targetRouterName: 'music-index',
        },
        // video-zone
        // music-tab-视频专区
        {
          name: '视频专区',
          targetRouterName: 'video-zone',
        },
      ],
    },
    {
      name: '武器库',
      targetRouterName: 'glequipment',
    },
  ],
  welfare_navs: [
    // {
    //   name: '常驻福利',
    //   targetRouterName: 'welfare',
    // },
    {
      name: '活动日历',
      targetRouterName: 'index-calendar',
    },
  ],
  square_navs: [
    {
      name: '推荐',
      targetRouterName: 'recommend',
    },
    {
      name: '附近',
      targetRouterName: 'nearby',
    },
    {
      name: '关注',
      targetRouterName: 'follow',
    },
  ],
  mine_navs: [
    {
      name: '个人主页',
      targetRouterName: 'mineindex',
    },
    {
      name: '游戏数据',
      targetRouterName: 'datainterest',
      children: [
        {
          name: '趣味数据',
          targetRouterName: 'datainterest',
        },
        {
          name: '道具数据',
          targetRouterName: 'datagrenade',
        },
        {
          name: '好友排行',
          targetRouterName: 'datafriend',
        },
      ],
    },
    {
      name: '社区互动',
      targetRouterName: 'mythumbup',
      children: [
        // {
        //   name: '我的发表',
        //   targetRouterName: 'myrelease',
        // },
        // {
        //   name: '我的发表',
        //   targetRouterName: 'mymsg',
        // },
        {
          name: '我的点赞',
          targetRouterName: 'mythumbup',
        },
        // {
        //   name: '我的点赞',
        //   targetRouterName: 'mythumbupnew',
        // },
        // {
        //   name: '我的点踩',
        //   targetRouterName: 'mythumbup2',
        // },
        // {
        //   name: '系统消息',
        //   targetRouterName: 'myrelease',
        // },
        {
          name: '系统消息',
          targetRouterName: 'mymsg',
        },
      ],
    },
    // {
    //   name: '个人主页',
    //   targetRouterName: 'XXX',
    // },
  ],
  guest_navs: [
    {
      name: 'TA的主页',
      targetRouterName: 'otherindex',
    },
    {
      name: '游戏数据',
      targetRouterName: 'guestdatainterest',
      children: [
        {
          name: '趣味数据',
          targetRouterName: 'guestdatainterest',
        },
        {
          name: '道具数据',
          targetRouterName: 'guestdatagrenade',
        },
        {
          name: '好友排行',
          targetRouterName: 'guestdatafriend',
        },
      ],
    },
  ],
};


export default navList;
